import '@babel/polyfill'
import './modules/gsap'
import GLightbox from 'glightbox'
import './modules/menu-scroll'
import './modules/choices'
import './modules/swiper'
import './modules/contact-form'
import './modules/bse-widget'

import { lazyLoading } from './modules/lazyload'
import { pageLoad } from './modules/page-loader'
import { menuScroll } from './modules/menu-scroll'
import { hamburgerAnimate } from './modules/hamburger'
import { registerNestedMenu } from './modules/menu-nested'
import { registerTabPanel } from './modules/tab-panel'
import { registerReadMore } from './modules/read-more'

hamburgerAnimate()
registerNestedMenu()
pageLoad()
registerTabPanel()
registerReadMore()

const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  autoplayVideos: false,
})
